export default "__VITE_ASSET__H_c2J5Lb__"